import { NgOptimizedImage } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
    OnChanges,
    Output,
    computed,
    inject,
} from '@angular/core';

import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { CardThemeSurface, SportsThemedCardHeaderDirective } from '@frontend/sports/common/ui/sports-themed-card';
import { CompetitionLogoComponent } from '@frontend/sports/competition-logos/feature';
import { ItemComponent } from '@frontend/sports/item/feature';
import { TitleIconOptions } from '@frontend/sports/types/components/content';
import { DsCardHeader } from '@frontend/ui/card-header';
import { DsTouchClickDirective } from '@frontend/ui/shared';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

export interface LinkConfig {
    link?: string;
    linkText?: string;
    disableLinkTextAndClick?: boolean;
}

@Component({
    selector: 'ms-widget-header',
    templateUrl: './widget-header.component.html',
    styleUrl: './widget-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    hostDirectives: [{ directive: DsTouchClickDirective }],
    imports: [
        ItemComponent,
        CompetitionLogoComponent,
        IconCustomComponent,
        NgOptimizedImage,
        TrustPipe,
        DsCardHeader,
        SportsThemedCardHeaderDirective,
    ],
})
export class WidgetHeaderComponent implements OnChanges {
    @HostBinding('class') className = 'widget-header grid-outer-title';

    @HostBinding('class.clickable-widget-header')
    get isClickableHeader() {
        return this.linkConfig?.disableLinkTextAndClick;
    }

    @HostBinding('class.hidden')
    get isHidden() {
        return (
            !this.title &&
            !(this.titleIcon && this.fallbackIcon) &&
            !this.customHeaderIcon &&
            !(this.linkConfig && this.linkConfig.link && (this.linkConfig.linkText || this.linkConfig.disableLinkTextAndClick)) &&
            !this.headerChevronLink
        );
    }

    @Input() title?: string;
    @Input() titleIcon: string;
    @Input() fallbackIcon?: string;
    @Input() sportId?: number;
    @Input() leagueId?: string;
    @Input() linkConfig: LinkConfig;
    @Input() customHeaderIcon?: string;
    @Input() headerChevronLink?: string;

    @Output() linkClick = new EventEmitter<boolean>();
    titleLogo: boolean;

    @HostListener('click', ['$event'])
    onClick(): void {
        if (this.linkConfig.disableLinkTextAndClick) {
            this.linkClicked();
        }
    }

    themeHeaderSurface: CardThemeSurface = {
        'mgm-dice': 'low',
        'sports-interaction': 'highest',
        'sportingbet-br': 'high',
        'betboo-br': 'high',
    };
    private readonly epcotConfig = inject(EpcotConfig);
    readonly isEpcotEnabled = computed(() => this.epcotConfig.isEnabled);

    ngOnChanges(): void {
        this.titleLogo = this.titleIcon === TitleIconOptions.CompetitionLogo;
    }

    linkClicked(): void {
        this.linkClick.emit(true);
    }
}
